export const $ = (sel, ctx = document) => ctx.querySelector(sel);

export const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
